import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { disable_report_loading : true, disable_report: '', disable_report_error: false};

export function disableReport(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_DISABLE_REPORT:
        return {
            disable_report_loading: true,
            disable_report: '',
            disable_report_error: false
        };
      case organisationConstants.RESPONSE_DISABLE_REPORT:
        return {
            disable_report_loading: false,
            disable_report: action.disable_report,
            disable_report_error: false
        };
      case organisationConstants.ERROR_DISABLE_REPORT:
        return { 
            disable_report_loading: false,
            disable_report: '',
            disable_report_error: true
        };
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/disableReport.reducer.js